const casesInit = () => {
  const title = document.querySelector(".case-slider__title");
  const posts = document.querySelectorAll(".cases-post__inner");

  gsap.registerPlugin(ScrollTrigger);

  const casesOptions = {
    slidesPerView: 3,
    navigation: {
      nextEl: ".cases-right",
      prevEl: ".cases-left",
    },
    breakpoints: {
      1920: {
        spaceBetween: 32,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
      },
      320: {
        spaceBetween: 16,
        slidesPerView: 1,
      },
    },
  };

  const cases = new Swiper(".cases-slider", casesOptions);

  if (title) {
    gsap.from(title, {
      opacity: 0,
      y: "100px",
      scrollTrigger: {
        trigger: title,
        start: "top 90%",
        end: "bottom bottom",
        toggleActions: "play none none reverse",
        once: true,
      },
    });
  }

  if (posts) {
    posts.forEach((span, i) => {
      gsap.from(span, {
        opacity: 0,
        y: "100px",
        delay: i * 0.2,
        scrollTrigger: {
          trigger: span,
          start: "top 90%",
          end: "bottom bottom",
          toggleActions: "play none none reverse",
          once: true,
        },
      });
    });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  casesInit();
});
